import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SecretGroupNotFoundErrorOptions = {
  secretGroup: ObjectId;
};

export class SecretGroupNotFoundError extends FleekError<SecretGroupNotFoundErrorOptions> {
  public name = 'SecretGroupNotFoundError';

  toString = () => {
    return 'Secret group was not found.';
  };
}
